export const getSortDirection = (sortDescending: boolean) => (sortDescending ? "desc" : "asc")
